<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-05-12 10:24:14
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-09 10:53:09
 * @FilePath: \YunYin_admin\src\views\Setting\RoleManagement\components\DetailRole.vue
-->
<template>
  <!-- 查看角色详情弹窗 -->
  <el-dialog
    class="dialog-bg dialog-role-detail"
    title="角色详情"
    :visible.sync="dialogRoleDetailVisible"
    :before-close="close"
    width="840px"
  >
    <ul class="list">
      <li class="item">
        <span class="left-side">角色名称：</span>
        <div class="right-side">{{ curRoleDetail.roleName }}</div>
      </li>
      <li class="item">
        <span class="left-side">角色描述：</span>
        <div class="right-side">{{ curRoleDetail.roleRemark }}</div>
      </li>
      <li class="item">
        <span class="left-side">角色权限：</span>
        <div class="right-side">
          <div class="auth-panel">
            <el-tree :data="ownAuthData" :props="defaultProps"></el-tree>
          </div>
        </div>
      </li>
      <li class="item" v-if="systemType == 2 || showList">
        <span class="left-side">角色成员：</span>
        <div class="right-side">
          <el-table :data="accounts" tooltip-effect="dark" style="width: 100%">
            <el-table-column label="序号" width="80" align="center">
              <template slot-scope="scope">
                {{
                  (pagination.currentPage - 1) * pagination.pageSize +
                  (scope.$index + 1)
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="fullName"
              label="人员姓名"
              min-width="8%"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="loginName"
              label="登录账号"
              min-width="12%"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="mobile"
              label="手机号"
              min-width="12%"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="created"
              label="账号新增时间"
              min-width="15%"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="total,prev, pager, next,jumper"
            :page-size="this.pagination.pageSize"
            :total="pagination.recordTotal"
            :hide-on-single-page="true"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </li>
    </ul>
  </el-dialog>
</template>

<script>
export default {
  name: "DetailRole",
  data() {
    return {
      accounts: [],
      defaultProps: {
        children: "children",
        label: "menuName",
      },
      ownAuthData: [],
      pagination: {
        currentPage: 1,
        pageSize: 5,
        recordTotal: 0,
      },
    };
  },
  props: {
    dialogRoleDetailVisible: {
      type: Boolean,
      default: () => true,
    },
    curRoleDetail: {
      type: Object,
      default: () => {},
    },
    systemType: {
      type: Number,
      default: 2,
    },
    showList: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  computed: {},
  methods: {
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-25 17:17:35
     */
    close() {
      this.$emit("close", "dialogRoleDetailVisible");
    },
    /**
     * @description: 获取权限
     * @Author: yangsibo
     * @Date: 2022-05-25 17:17:53
     */
    async getOwnAuthData() {
      try {
        let { data } = await this.$http.common.selectOwnSMenuTree({
          roleIdList: [this.curRoleDetail.id],
        });
        this.ownAuthData = data;
      } catch (error) {}
    },
    /**
     * @description: 获取成员列表
     * @Author: yangsibo
     * @Date: 2022-05-25 17:18:57
     */
    async getAccounts() {
      this.$http.account
        .getManageAccount({
          ...this.pagination,
          roleId: this.curRoleDetail.id,
          systemType: this.systemType,
        })
        .then((res) => {
          let { recordTotal, content: accounts } = res.data;
          this.pagination.recordTotal = recordTotal;
          this.accounts = accounts;
        });
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getAccounts();
    },
  },
  created() {},
  mounted() {
    this.getOwnAuthData();
    this.getAccounts();
  },
};
</script>
<style lang="scss" scoped>
.dialog-role-detail {
  .el-dialog__body {
    padding: 20px 30px;
    .list {
      .item {
        display: flex;
        line-height: 35px;
        color: #222222;
        font-size: 16px;
        .right-side {
          flex: 1;
          .auth-panel {
            width: 310px;
            min-height: 100px;
            max-height: 300px;
            overflow-y: auto;
            margin: 5px 0 10px;
            padding-top: 10px;
            background-color: #ffffff;
            border-radius: 2px;
            border: solid 1px #e5e6eb;
            &.active {
              background-color: #ffffff;
              border-radius: 3px;
              border: solid 1px #daf3f3;
              .role {
                color: #018388;
                background-color: #f1fafa;
                i {
                  color: #018388;
                }
              }
            }
            .role {
              display: flex;
              align-items: center;
              justify-content: space-between;
              height: 40px;
              padding: 0 10px;
              color: #222222;
              background-color: #f8f8f8;
              border-radius: 3px;
              cursor: pointer;
              i {
                color: #999;
                font-size: 16px;
              }
              label {
                margin-left: 5px;
              }
            }
          }
        }
      }
    }
  }
}
</style>

